// extracted by mini-css-extract-plugin
export default {"WayItem":"Skills_WayItem__WqE0t","WayItemHeader":"Skills_WayItemHeader__tPMDN"};